import useSWR from 'swr';
import { Logger } from '../utilities/logger';

const logError = (id: string, error: any, message: string) => {
    Logger.error('React Use API Ajax Error', {
        message: message,
        errors: [
            {
                id: id,
                type: 'Ajax Error: Use API',
                statusText: error?.statusText ?? 'UnknownStatus',
            },
        ],
        counts: 1,
        page: 'react',
    });
};

export const getLightningBaseUrl = () => {
    return '';
};

const LIGHTNING_BASE_URL = getLightningBaseUrl();

const createLightningFetcher =
    <T>() =>
    (path: string) =>
        fetch(`${LIGHTNING_BASE_URL}/${path}`)
            .then((res) => {
                if (res.ok) {
                    return res.json() as Promise<T>;
                } else {
                    logError(
                        res.status.toString(),
                        res,
                        `Unsuccessful response from ${LIGHTNING_BASE_URL}/${path}`
                    );
                    throw new HttpResponseError(res.status, res.statusText);
                }
            })
            .catch((error) => {
                logError(
                    'Exception',
                    error,
                    `Error when calling ${LIGHTNING_BASE_URL}/${path}`
                );
                throw error;
            });

export class HttpResponseError extends Error {
    constructor(status: number, statusText: string) {
        super(`HTTP Error: ${status} - ${statusText}`);
        this.name = 'HttpResponseError';
        this.status = status;
        this.statusText = statusText;
    }
    public status: number;
    public statusText: string;
}

export const useApi = <T>(
    params: {
        path: string | null;
        query?: { prop: string; value: string }[];
    } | null
) => {
    let path = params?.path;
    if (path && path.startsWith('/')) {
        path = path.substring(1);
    }

    if (params?.query) {
        path += `?${params.query
            .map((query) => `${query.prop}=${encodeURIComponent(query.value)}`)
            .join('&')}`;
    }

    return useSWR(path, createLightningFetcher<T>());
};

const getUrlAdvantage = (): RegExpMatchArray | null => {
    const path = window?.location?.pathname;
    const contentRegex = /^\/([^/]+)\/content/;
    if (contentRegex.test(path)) {
        return path.match(contentRegex);
    } else {
        return null;
    }
};

export const getAdvantagePath = (): string => {
    // RegExpMatchArray[0] is the full matching string
    return getUrlAdvantage()?.[0] ?? '';
};

export const getAdvantageKeyFromUrl = (): string | undefined => {
    // RegExpMatchArray[1+] are the capture groups (parens)
    return getUrlAdvantage()?.[1] ?? undefined;
};
